import { render, staticRenderFns } from "./cookie-pop.vue?vue&type=template&id=1c8366ca&scoped=true&"
import script from "./cookie-pop.vue?vue&type=script&lang=js&"
export * from "./cookie-pop.vue?vue&type=script&lang=js&"
import style0 from "./cookie-pop.vue?vue&type=style&index=0&id=1c8366ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c8366ca",
  null
  
)

export default component.exports